import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { documentAPI } from '../../services/api';

export const fetchDocuments = createAsyncThunk('document/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await documentAPI.getAll(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch documents');
  }
});

export const deleteDocument = createAsyncThunk('document/delete', async (id, { rejectWithValue }) => {
  try {
    await documentAPI.delete(id);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete document');
  }
});

const documentSlice = createSlice({
  name: 'document',
  initialState: { documents: [], loading: false, error: null, pagination: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocuments.pending, (state) => { state.loading = true; })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.data || [];
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchDocuments.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.documents = state.documents.filter(d => d.id !== action.payload);
      });
  },
});

export const { clearError } = documentSlice.actions;
export default documentSlice.reducer;
